<ng-container #loaderContainer></ng-container>
<app-footer *ngIf="showFooter"></app-footer>
